import { CheckCircle2 } from "lucide-react";
import { Stars } from "../Stars";
import { AFFILIATE_URL, AFF_DISCLOSURE } from "../../lib/constants";
import { trackCta } from "../../lib/tracking";

export const WinnerCard = () => (
  <section className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 -mt-16 relative z-10" data-testid="winner-spotlight-card">
    <div className="relative bg-white border-t-4 border-[#5A31F4] rounded-lg shadow-xl p-8 sm:p-12">
      <span className="absolute -top-4 left-8 bg-[#5A31F4] text-white text-xs font-bold uppercase tracking-[0.15em] px-4 py-1.5 rounded-full shadow-md" data-testid="winner-badge">
        ⭐ Our Top Recommendation for 2026
      </span>
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
        <div className="lg:col-span-3">
          <div className="flex items-center gap-4 flex-wrap">
            <h2 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-[#0F172A]">ElevenLabs</h2>
            <span className="flex items-center gap-2">
              <Stars rating={4.9} size={18} />
              <span className="font-bold text-[#0F172A]">4.9 / 5.0</span>
            </span>
          </div>
          <p className="mt-4 text-base text-slate-700 leading-relaxed">
            In our editorial evaluation, ElevenLabs is our top recommendation for AI voice in 2026. Its voice cloning is highly rated, its multilingual support covers 29 languages, and the free tier lets you start with zero commitment. For developers, the API is among the most capable on the market. For creators, the studio interface is intuitive and fast.
          </p>
        </div>
        <div className="lg:col-span-2">
          <ul className="space-y-3 mb-6">
            {[
              "Highly rated voice cloning — remarkably close to real speech",
              "29+ languages including regional accents",
              "Full API access — ideal for developers building voice-enabled apps",
            ].map((pro) => (
              <li key={pro} className="flex items-start gap-2.5 text-sm text-slate-700">
                <CheckCircle2 className="w-5 h-5 text-[#16A34A] shrink-0 mt-0.5" />
                {pro}
              </li>
            ))}
          </ul>
          <a
            href={AFFILIATE_URL}
            target="_blank"
            rel="nofollow sponsored noopener"
            onClick={() => trackCta("winner-card", AFFILIATE_URL)}
            data-testid="cta-winner-card"
            className="block w-full text-center bg-[#5A31F4] text-white hover:bg-[#4B29CD] rounded-md px-8 py-4 font-bold text-lg transition-all duration-200 shadow-md hover:-translate-y-1"
          >
            Start Free with ElevenLabs →
          </a>
          <p className="text-xs text-slate-500 text-center mt-2.5">Free plan available. No credit card required.</p>
          <p className="text-xs text-slate-500 text-center mt-2" data-testid="winner-affiliate-disclosure">{AFF_DISCLOSURE}</p>
        </div>
      </div>
    </div>
  </section>
);
